import React, { Fragment, useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Dialog from "../../../atoms/dialog";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { validateNameLabel } from "../SystemModel/helpers";

import { onTransctionCreation, onTransactionInvoke } from "../../../../store/constructs/transactions/actions"
import { getClusterlets } from "../../../../store/constructs/clusterlets/selectors";
import { setSelectedTransactionId, reRenderInfoBuilder } from "../../../../store/global/actions";
import { constructIds } from "../../../../config/common";
import { wholeNumber } from "../../../../config/validations";
import { invokePostService, invokeGetService, setReRender, handleSnackBar, setNestedTransactionEvents, setNestedTransactionClusterlets, setNestedTransactionChildren, setParentTransaction } from "../../../../store/global/actions";
import { useParams } from 'react-router-dom';
import { getNestedTransactionEvents, getNestedTransactionClusterlets, getNestedTransactionChildren, getParentTransaction, getNestedTransactionInvoked } from '../../../../store/global/selectors';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { validationMessages, basic } from '../../../../config/validations';

import {
  getDigitalTwins,
  getExternalFunctions,
  getAnalytics,
  getSensors
} from "../../../../store/constructs/clusterlets/selectors";
import { getTransaction, getSelectedTransactions, getNestedTransactions } from "../../../../store/constructs/transactions/selectors";
const shortUUiD = require("short-uuid");

const CreateTranasction = (props) => {
  const { isEdit, fullWidth, handleClose, isListView, editValue, contentOnly } =
    props;

  const {
    trigger,
    register,
    control,
    reset,
    errors = {},
    getValues,
  } = useForm();

  let transaction_Id = 0;
  let nested_transaction_Id = 0;
  let invoked_transaction_Id = 0;

  constructIds.forEach((Id, index) => {
    if (Id.type === "transaction") transaction_Id = Id.id;
    if (Id.type === "nested_transaction") nested_transaction_Id = Id.id;
    if (Id.type === "invoked_transaction") invoked_transaction_Id = Id.id;
  })


  React.useEffect(() => {
    if (editValue && isEdit) toggle();
    else reset({ autotrigger: false });
    if (props.submitRef) props.submitRef.current = onSubmit;
  }, []);

  const [open, setOpen] = React.useState(false);
  const [openAlert, setopenAlert] = React.useState(false);
  const toggle = () => setOpen((prev) => !prev);
  const [transactionNameValidation, setTransactionNameValidation] =
    React.useState("");


  const digitalTwins = useSelector(getDigitalTwins);
  const externalfunctions = useSelector(getExternalFunctions);
  const analytics = useSelector(getAnalytics);
  const sensors = useSelector(getSensors);
  const transactionList = useSelector(getTransaction);
  const selectedTranaction = useSelector(getSelectedTransactions);
  const new_clusterlets = useSelector(getClusterlets);
  let clusterlet_ids = [];

  React.useEffect(() => {

    const condition = open && isEdit && editValue;
    let sel = {};
    let node_elements = [];
    let digitalTwin_names = [];
    let externalFunction_names = [];
    let analytics_names = [];
    let sensors_names = [];
    let clusterletInTransaction = [];

    digitalTwins.forEach((digitalTwin, index) => { digitalTwin_names.push(digitalTwin.name) })
    externalfunctions.forEach((externalfunction, index) => { externalFunction_names.push(externalfunction.name) })
    analytics.forEach((analytic, index) => { analytics_names.push(analytic.name) })
    sensors.forEach((sensor, index) => { sensors_names.push(sensor.name) })

    if (condition) {

      const array = [...digitalTwin_names, ...externalFunction_names, ...analytics_names, ...sensors_names];


      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (externalFunction_names.includes(element)) sel[`delegate.${element}`] = false;
        if (digitalTwin_names.includes(element)) sel[`selected.${element}`] = false;
        if (analytics_names.includes(element)) sel[`analytic.${element}`] = false;
        if (sensors_names.includes(element)) sel[`sensor.${element}`] = false;
      }



      const { json = [], ...rest } = editValue;

      const set = {
        //...sel,
        ...rest,
        //autotrigger: Boolean(json.find((i) => i.tag === "callflow")),
        autotrigger: selectedTranaction.autoTrigger,
      };

      reset(set);
    }
  }, [open]);

  const dispatch = useDispatch();

  const onSubmit = (callbackEnabled) => {

    trigger().then((result) => {

      if (!result) return;


      const digitalTwins = [];
      const delegates = [];
      const analytics = [];
      const sensors = [];


      const {
        selected,
        autotrigger,
        // uuid,
        id,
        delegate = {},
        analytic = {},
        sensor = {},
        ...values
      } = getValues();

      let selectedClusterletCount = 0;
      let selectedDelegateCount = 0;

      //transaction name must be unique
      const createTransactionName = values.name;

      const transactionListWithoutSelectedTransaction = transactionList.filter(
        (t) => t.id !== id
      );
      if (transactionListWithoutSelectedTransaction.length) {
        const TransactionNameDefined =
          transactionListWithoutSelectedTransaction.find(
            (t) => t.name.toLowerCase() === createTransactionName.toLowerCase()
          );
        if (TransactionNameDefined) {
          setTransactionNameValidation(
            "Transaction with this name already exists."
          );
          return;
        }
      }

      Object.keys(selected).forEach((key) => {
        if (selected[key]) digitalTwins.push(key);
      });

      Object.keys(delegate).forEach((key) => {
        if (delegate[key]) delegates.push(key);
      });

      Object.keys(analytic).forEach((key) => {
        if (analytic[key]) analytics.push(key);
      });

      Object.keys(sensor).forEach((key) => {
        if (sensor[key]) sensors.push(key);
      });

      let nodes = delegates.concat(digitalTwins, analytics, sensors);
      let events = [];
      //const newTransaction = transactionList.find((t) => t.uuid === uuid);
      const newTransaction = transactionList.find((t) => t.id === id);


      nodes.forEach((node, index) => {
        new_clusterlets.forEach((clusterlet) => {
          if (node === clusterlet.name) {
            clusterlet_ids.push({ id: clusterlet.id, order: index })
          }
        })
      })

      const new_transaction = {
        name: values.name,
        id: id ? id : shortUUiD.generate(),
        type: transaction_Id,
        description: values.desc,
        autoTrigger: autotrigger,
        clusterlets: clusterlet_ids,
        invokedTransactions: [],
        nestedTransactions: [],
        templateTransactions: [],
        events: [],
      }

      for (let item in selected) {
        if (digitalTwins !== undefined) {

          digitalTwins.forEach(clusterlet => {
            if (clusterlet == item) {
              selectedClusterletCount++;
            }
          })
        }
        if (delegates !== undefined) {
          delegates.forEach(delegate => {
            if (delegate == item) {
              selectedDelegateCount++;
            }
          })
        }
      }


      if ((selectedClusterletCount <= 1 && delegates.length == 0) || (selectedClusterletCount == 0 && delegates.length <= 1)) {
        setopenAlert(true);
        return
      }

      const isCallbackEnabled = callbackEnabled?.current;

      //dispatch(onTransctionCreate(transaction, Boolean(isCallbackEnabled)));
      dispatch(onTransctionCreation(new_transaction, Boolean(isCallbackEnabled)));
      dispatch(setSelectedTransactionId(new_transaction.id, Boolean(isCallbackEnabled)));


      toggle();
      if (isEdit) isEdit(true);

      if (isCallbackEnabled) callbackEnabled.current();
      else if (props.handleClose) props.handleClose();

      dispatch(reRenderInfoBuilder())

    });
  };

  const render = (
    <Grid container direction={"row"} spacing={1}>
      <Grid item xs={12}>
        <input {...register("id")} style={{ display: "none" }} />
        <TextField
          InputLabelProps={{
            shrink: true,
          }}
          type={"text"}
          fullWidth
          required
          label={"Name"}
          placeholder={"Name"}
          variant="outlined"
          name={"name"}
          error={Boolean(errors.name && errors.name)}
          inputRef={register({ required: true, validate: validateNameLabel })}
          helperText={Boolean(errors.name && errors.name) ? "Whitespace and special characters not allowed" : ""}
        />
      </Grid>

      {transactionNameValidation && transactionNameValidation.length && (
        <small style={{ color: "red" }}>
          &nbsp;&nbsp;
          {transactionNameValidation}
          <br></br>
          <br></br>
        </small>
      )}

      <Grid item xs={12}>
        <TextField
          InputLabelProps={{
            shrink: true,
          }}
          type={"text"}
          fullWidth
          required
          multiline
          rows={4}
          label={"Description"}
          placeholder={"Description"}
          variant="outlined"
          name={"desc"}
          error={Boolean(errors && errors.desc)}
          inputRef={register({ required: true })}
        />
      </Grid>

      {/* <Grid item xs={12}>
        <Controller
          control={control}
          rules={{ required: false }}
          name={`autotrigger`}
          render={({ onChange, value, ...rest }) => {
            const onCheck = (event) => {
              onChange(event.target.checked);
            };
            return (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={value}
                    onClick={onCheck}
                    {...rest}
                    color="primary"
                  />
                }
                label={"Auto trigger"}
              />
            );
          }}
        />
      </Grid> */}

      {externalfunctions && externalfunctions.length ? (
        <Grid item xs={12}>
          <Grid container direction={"row"} spacing={1}>
            <Grid item xs={12}>
              <Typography>
                Select Delegates involved in transaction
              </Typography>
            </Grid>
            {externalfunctions.map((delegate) => {
              return (
                <Controller
                  defaultValue={!Boolean(isEdit)}
                  control={control}
                  rules={{ required: false }}
                  name={`selected.${delegate.name}`}
                  render={({ onChange, value, ...rest }) => {
                    const onCheck = (event) => {
                      onChange(event.target.checked);
                    };
                    return (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value}
                            onClick={onCheck}
                            {...rest}
                            color="primary"
                          />
                        }
                        label={delegate.name}
                      />
                    );
                  }}
                />
              );
            })}
          </Grid>
        </Grid>
      ) : null}
      {analytics && analytics.length ? (
        <Grid item xs={12}>
          <Grid container direction={"row"} spacing={1}>
            <Grid item xs={12}>
              <Typography>
                Select {process.env.REACT_APP_ANALYTICS} involved in transaction
              </Typography>
            </Grid>
            {analytics.map((analytic) => {
              return (
                <Controller
                  defaultValue={!Boolean(isEdit)}
                  control={control}
                  rules={{ required: false }}
                  name={`selected.${analytic.name}`}
                  render={({ onChange, value, ...rest }) => {
                    const onCheck = (event) => {
                      onChange(event.target.checked);
                    };
                    return (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value}
                            onClick={onCheck}
                            {...rest}
                            color="primary"
                          />
                        }
                        label={analytic.name}
                      />
                    );
                  }}
                />
              );
            })}
          </Grid>
        </Grid>
      ) : null}
      {sensors && sensors.length ? (
        <Grid item xs={12}>
          <Grid container direction={"row"} spacing={1}>
            <Grid item xs={12}>
              <Typography>
                Select Sensors involved in transaction
              </Typography>
            </Grid>
            {sensors.map((sensor) => {
              return (
                <Controller
                  defaultValue={!Boolean(isEdit)}
                  control={control}
                  rules={{ required: false }}
                  name={`selected.${sensor.name}`}
                  render={({ onChange, value, ...rest }) => {
                    const onCheck = (event) => {
                      onChange(event.target.checked);
                    };
                    return (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value}
                            onClick={onCheck}
                            {...rest}
                            color="primary"
                          />
                        }
                        label={sensor.name}
                      />
                    );
                  }}
                />
              );
            })}
          </Grid>
        </Grid>
      ) : null}
      {digitalTwins && digitalTwins.length ? (
        <Grid item xs={12}>
          <Grid container direction={"row"} spacing={1}>
            <Grid item xs={12}>
              <Typography>
                Select Digital Twins involved in transaction
              </Typography>
            </Grid>
            {digitalTwins && digitalTwins.length
              ? digitalTwins.map((clusterlet) => {
                return (
                  <Controller
                    control={control}
                    rules={{ required: false }}
                    name={`selected.${clusterlet.name}`}
                    defaultValue={!Boolean(isEdit)}
                    render={({ onChange, value, ...rest }) => {
                      const onCheck = (event) => {
                        onChange(event.target.checked);
                      };
                      return (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={value}
                              onClick={onCheck}
                              {...rest}
                              color="primary"
                            />
                          }
                          label={clusterlet.name}
                        />
                      );
                    }}
                  />
                );
              })
              : null}
          </Grid>
        </Grid>
      ) : (
        <Typography>
          Create Digital twins in hierarchical flow. Before creating information
          flow
        </Typography>
      )}
    </Grid>
  );

  if (contentOnly) return render;

  return (
    <Fragment>
      {isListView ? (
        <ListItem onClick={toggle} fullWidth={Boolean(fullWidth)} button>
          <ListItemText primary={"Create Transaction"} />
        </ListItem>
      ) : (
        !isEdit && (
          <Button
            id="createTransaction"
            onClick={toggle}
            fullWidth={Boolean(fullWidth)}
            variant="outlined"
            color="primary"
            size={fullWidth ? "large" : "small"}
          >
            Create
          </Button>
        )
      )}

      {open && (
        <Dialog
          title="Create Transaction"
          open={open}
          handleClose={() => {
            toggle();
            if (isEdit) isEdit(true);
          }}
          actions={
            <Button
              id="transactionSubmit"
              disabled={!Boolean(digitalTwins && digitalTwins.length)}
              onClick={onSubmit}
              color="primary"
              variant="contained"
              style={{ marginLeft: 10 }}
            >
              Submit
            </Button>
          }
        >
          {render}
        </Dialog>
      )}
      <Dialog
        title="Create Transaction"
        open={openAlert}
        handleClose={() => {
          setopenAlert(false);
          if (isEdit) isEdit(true);
        }}
        actions={
          <Button
            id="transactionSubmit"
            disabled={!Boolean(digitalTwins && digitalTwins.length)}
            onClick={() => {
              setopenAlert(false);
            }}
            color="primary"
            variant="contained"
            style={{ marginLeft: 10 }}
          >
            OK
          </Button>
        }
      >
        {digitalTwins.length < 1 ? "Please select atleast 2 clusterlets to create a transaction" : "Please select more than one Digital Twin to create a transaction"}
      </Dialog>

    </Fragment>
  );
};

export default CreateTranasction;


export const AddTransactionWithinATransaction = (props) => {

  const dispatch = useDispatch();
  const params = useParams();
  const { open: openValue, handleClose, contentOnly, selected } = props;
  const [editStat, seteditStat] = React.useState(0);
  const [value, setValue] = React.useState(0);
  const [selectedInnerTrans, setselectedInnerTrans] = React.useState("");
  const [transName, settransName] = React.useState("");
  const [disableEdit, setDisableEdit] = React.useState(false);
  const [selectedBehaviour, setSelectedBehaviour] = React.useState(null);


  const nestedTransId = openValue

  const { delegates, clusterlets, analytics, sensors, nodes } = selected;

  const nested_transactionList = useSelector(getNestedTransactions);
  const transactionsList = useSelector(getTransaction);
  const nestedTransactionEvents = useSelector(getNestedTransactionEvents);
  const nestedTransactionClusterlets = useSelector(getNestedTransactionClusterlets);
  const nestedTransactionChildren = useSelector(getNestedTransactionChildren);
  const nestedTransactionInvoked = useSelector(getNestedTransactionInvoked);
  const parentTransaction = useSelector(getParentTransaction);

  let nodesIntransaction = [];
  let transactionType;
  const new_clusterlets = useSelector(getClusterlets);

  new_clusterlets.forEach((clusterlet, index) => {
    clusterlets.forEach((node, key) => {
      if (clusterlet.id === node.id) {
        nodesIntransaction.push({ id: clusterlet.id, order: index });
      }
    })
  })

  React.useEffect(() => {
    props.forImport(0);
    //props.forDel(0);

  })

  const handleChange = (event, newValue) => {
    setValue(newValue)
    props.forDel(newValue);

    const { name, oneof } = getValues();
    settransName(name);
  };


  const {
    trigger,
    register,
    control,
    reset,
    errors = {},
    getValues,
    setError
  } = useForm();

  const isEdit = typeof openValue === "string";

  React.useEffect(() => {

    if (selected && typeof openValue === "string") {
      const nested_item = selected.nestedTransactions.find(
        (i) => i.id === openValue
      );

      const invoked_item = selected.invokedTransactions.find(
        (i) => i.id === openValue
      );

      if (nested_item && !invoked_item) {
        let values = {}
        nested_transactionList.forEach((tr, index) => {
          if (tr.id === nested_item.id) {
            values.name = tr.name;
            values.oneof = tr.oneof
            transactionType = 0;
          }
        })
        reset(values);
      }
      else if (!nested_item && invoked_item) {
        let values = {}
        transactionsList.forEach((tr, index) => {
          if (tr.id === invoked_item.id) {
            values.name = tr.name;
            values.oneof = invoked_item.oneof
            setDisableEdit(true);
            transactionType = 1;
          }
        })
        reset(values);
      }
    }

    if (props.submitRef) props.submitRef.current = onSubmit;
    if (isEdit) seteditStat(1)
    else seteditStat(0)



  }, [isEdit]);


  const onSubmit = () => {
    trigger().then((result) => {

      if (!result) return;
      const { name, desc, condition, loop, oneof, behaviour, optional, continueontimeout, scatter_inst, timeout} = getValues();
      const items = [];
      const selectedIndexs = [];
      let transNodes = {};
      const id = shortUUiD.generate();

      if (transactionType === 1 && isEdit) {
        const editInvoked = { id: nestedTransId, condition: oneof }
        dispatch(onTransactionInvoke(selected.id, editInvoked));
        dispatch(reRenderInfoBuilder())
        if (handleClose) handleClose();
      }
      else {

        let highestOrder = props.transactionYPosition

        const nested_transaction = {
          name: name,
          description: desc,
          type: constructIds[7].id,
          clusterlets: nodesIntransaction,
          timeout,
          events: []
        }

        if (behaviour === 'oneof') {
          nested_transaction.oneof = true;
        } else if (behaviour === 'condition') {
          nested_transaction.oneof = false;
          nested_transaction.condition = condition;
        } else if (behaviour === 'loop') {
          nested_transaction.oneof = false;
          nested_transaction.loop = loop;
        } else if (behaviour === 'noneofthese') {
          nested_transaction.oneof = false;
          nested_transaction.loop = false;
        } 

        if (optional) nested_transaction.optional = true
        if (continueontimeout) nested_transaction.continueontimeout = true 
        if (scatter_inst) nested_transaction.scatter_inst = true
        
        const nestedTansactionIdInTransaction = {
          id: (nestedTransId !== null) ? nestedTransId : id,
          order: highestOrder,
        };

        if (nestedTransactionEvents.length > 0) {
          nested_transaction.events = nestedTransactionEvents
        }

        if (nestedTransactionClusterlets.length > 0) {
          nested_transaction.clusterlets = nestedTransactionClusterlets
        }

        if (nestedTransactionChildren.length > 0) {
          nested_transaction.nestedTransactions = nestedTransactionChildren
        }

        if (nestedTransactionInvoked.length > 0) {
          nested_transaction.invokedTransactions = nestedTransactionInvoked;
        }

        if(nested_transaction.loop == false)
        {
          delete nested_transaction.loop;
        }

        dispatch(invokePostService('createNestedTransaction', { nestedTransaction: nested_transaction, order: highestOrder }, [parentTransaction != '' ? parentTransaction : params.transaction]))
          .then(savedData => {
            if (savedData.status) {
              dispatch(setReRender());
              dispatch(handleSnackBar({ open: true, message: 'Child transaction created', severity: 'success' }));
              if (handleClose) handleClose();
              dispatch(setNestedTransactionEvents([]))
              dispatch(setNestedTransactionClusterlets([]))
              dispatch(setNestedTransactionChildren([]))
              dispatch(setParentTransaction(''))
              dispatch(reRenderInfoBuilder())

            } else {
              if (savedData?.code === "600") {
                savedData?.errors?.forEach(error => {

                    setError(error.name, {message: error.message});
                });
            }
            }
          })
          .catch(error => console.error(error));

      }


    });
  };

  const handleRadioBtnChange = (event) => {
    if(event.target.value == 'noneofthese')
        setSelectedBehaviour('noneofthese');
    else  
        setSelectedBehaviour(event.target.value);
  }
  const open = Boolean(openValue);

  const render = (
    <Grid container direction={"row"} spacing={3}>
      <Grid item xs={12} style={{display: "flex", gap: '1rem'}}>
        <Grid item xs={9}>
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            disabled={disableEdit}
            // helperText={disableEdit ? "For reused transaction, name cannot edit from here" : ""}
            type={"text"}
            fullWidth
            required
            label={"Name"}
            placeholder={"Name"}
            variant="outlined"
            name={"name"}
            error={Boolean(errors.name)}
            inputRef={register({ ...basic })}
            helperText={errors?.name ? errors?.name?.message ? errors.name.message : validationMessages[errors?.name?.type] : ''}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            disabled={disableEdit}
            // helperText={disableEdit ? "For reused transaction, name cannot edit from here" : ""}
            type={"number"}
            fullWidth
            label={"Timeout"}
            placeholder={"Timeout"}
            variant="outlined"
            name={"timeout"}
            inputRef={register({...wholeNumber})}
            error={errors?.timeout ? true : false}
            helperText={errors?.timeout && errors?.timeout?.message ? errors.timeout.message : ''}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Controller
          name="optional"
          control={control}
          render={({ field, onChange }) =>
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  onChange={e => {
                    onChange(e.target.checked)
                  }}
                  name="optional"
                  id="optional"
                  color="primary"
                />
              }
              label="Optional"
            />
          }
        />
        <Controller
          name="continueontimeout"
          control={control}
          render={({ field, onChange }) =>
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  onChange={e => {
                    onChange(e.target.checked)
                  }}
                  name="continueontimeout"
                  id="continueontimeout"
                  color="primary"
                />
              }
              label="ContinueOnTimeout"
            />
          }
        />
        <Controller
          name="scatter_inst"
          control={control}
          render={({ field, onChange }) =>
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  onChange={e => {
                    onChange(e.target.checked)
                  }}
                  name="scatter_inst"
                  id="scatter_inst"
                  color="primary"
                />
              }
              label="ScatterInst"
            />
          }
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          InputLabelProps={{
            shrink: true,
          }}
          type={"text"}
          name={"desc"}
          fullWidth
          multiline={true}
          rows={2}
          label={"Description"}
          variant="outlined"
          inputRef={register({ required: false, })}
        />
      </Grid>
      <Grid item xs={8}>
        <Controller
          control={control}
          rules={{ required: false }}
          name={`behaviour`}
          defaultValue={selectedBehaviour}
          render={({ onChange, value, ...rest }) => {

            return (
              <RadioGroup aria-label="behaviour"  style={{ flexDirection: 'row' }} name="behaviour" value={selectedBehaviour} onChange={e => { handleRadioBtnChange(e); onChange(e); }}>
                <FormControlLabel value="condition" control={<Radio color="#364150" />} label="Condition" />
                <FormControlLabel value="loop" control={<Radio color="#364150" />} label="Loop" />
                <FormControlLabel value="oneof" control={<Radio color="#364150" />} label="Oneof" />
                <FormControlLabel value="noneofthese" control={<Radio color="#364150" />} label="None of these" />
                {/* <FormControlLabel value="allof" control={<Radio color="#364150" />} label="Allof" />
                <FormControlLabel value="anyof" control={<Radio color="#364150" />} label="Anyof" /> */}

              </RadioGroup>
            );
          }}
        />
      </Grid>

      {selectedBehaviour === 'condition' &&
        <Grid item xs={12}>
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            type={"text"}
            name={"condition"}
            fullWidth
            label={"Condition"}
            variant="outlined"
            error={errors?.condition ? true : false}
            inputRef={register({ required: true })}
            helperText={Boolean(errors.condition) ? validationMessages[errors?.condition?.type] : ""}
          />
        </Grid>}


      {selectedBehaviour === 'loop' && <Grid item xs={12}>
        <TextField
          InputLabelProps={{
            shrink: true,
          }}
          type={"text"}
          name={"loop"}
          fullWidth
          label={"Loop Function Name"}
          variant="outlined"
          error={errors?.loop ? true : false}
          inputRef={register({ required: true })}
          helperText={Boolean(errors.loop) ? validationMessages[errors?.loop?.type] : ""}
        />
      </Grid>}

    </Grid>

  );

  if (contentOnly) return render;

  return (
    <Dialog
      title="Add Transction"
      open={open}
      handleClose={handleClose}
      actions={
        <Button
          id="addTransactionSubmit"
          onClick={onSubmit}
          color="primary"
          variant="contained"
          style={{ marginLeft: 10 }}
        >
          Submit
        </Button>
      }
    >
      {render}
    </Dialog>
  );
};

export const ImportTransaction = (props) => {

  const dispatch = useDispatch();
  const params = useParams();

  const { open: openValue, handleClose, contentOnly, selected } = props;
  const [selectedOption, setselectedOption] = React.useState("");
  const [condition, setcondition] = React.useState("");

  const { delegates, clusterlets, analytics, sensors } = selected;
  // const mainTransaction = useSelector(getSelectedTranaction);

  // const transactionList = useSelector(getTransaction);
  const [transactionList, setTransactionList] = useState([])
  // const mainTransaction = useSelector(getSelectedTransactions);

  // const transactionOptions = transactionList.filter(i => i._id != mainTransaction.id)
  const [transactionOptions, setTransactionOptions] = useState([])
  var selectedTransaction = [];


  useEffect(() => {
    dispatch(invokeGetService('getBlueprintConstructs', []))
      .then((response) => {
        if (response.data !== undefined) {
          setTransactionList(response.data.transactions);
          setTransactionOptions(response.data.transactions.filter(i => i._id != params.transaction && i.type == 7))

        }
      })
  }, [])


  useEffect(() => {
    props.forImport(1);
    props.forDel(0);
  }, []);

  const handleChange = (value) => {
    setcondition(value);
    props.con(value);
  };

  const onChange = (value) => {
    setselectedOption(value);
    //selectedTransaction = transactionOptions.filter(i => i.values.name === value)
    selectedTransaction = transactionOptions.filter(i => i.name === value)
    props.embeded(selectedTransaction);
  }

  const onSubmit = () => {

  };

  const open = Boolean(openValue);

  const render = (
    <Fragment>
      <TextField
        select
        InputLabelProps={{
          shrink: true,
        }}
        fullWidth
        label="Transaction"
        required
        placeholder="Select"
        onChange={(e) => onChange(e.target.value)}
        //disabled={options.loading}
        //ref={ref}
        //onBlur={onBlur}
        //name={name}
        //error={Boolean(errors.configurationId && errors.configurationId)}
        value={selectedOption}
        SelectProps={{
          native: true,
        }}
        variant="outlined"
      >
        <option key={"empty"} value={""}>
          Choose
        </option>
        {(transactionOptions || []).map((option) => (
          <option id={option._id} key={option.name} value={option.name}>
            {option.name}
          </option>
        ))}
      </TextField>
      <br></br>
      <br></br>
      <TextField
        InputLabelProps={{
          shrink: true,
        }}
        type={"text"}
        fullWidth
        label={"Condition"}
        placeholder={"Condition"}
        variant="outlined"
        name={"condition"}
        onChange={(e) => handleChange(e.target.value)}
      //error={Boolean(errors.oneof && errors.oneof)}
      //inputRef={register({ required: true })}
      />
    </Fragment>

  );
  if (contentOnly) return render;
};